import Link from 'next/link';

import { classNames } from '@/utils/classNames';
// Utils
import useUserRole from '@/utils/hooks/user/useUserRole';

// Types
import type useGetGlobalInfo from '@/utils/layout/globalInfoDisclaimer/useGetGlobalInfo';

// Libs
import { SUBSCRIPTION_INVOICES } from '@/lib/routes/privateRoutes';
import { CHANGE_PAYMENT_METHOD } from '@/lib/settings/subscriptionInvoices/steps';

import { Trans } from '@/components/tools/translation';
// Components
import { BannerTemplate } from '@/components/layouts/LayoutPlatform/components/Header/components/GlobalInfoDisclaimer/Popover/BannerTemplate';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

type PastDueBannerProps = {
    bannerInfo: ReturnType<typeof useGetGlobalInfo>['banners']['pastDue'];
};

export function PastDueBanner({ bannerInfo }: PastDueBannerProps) {
    const { isAdmin } = useUserRole();
    const { subscription } = useSubscription();
    const isManualSubscription = subscription?.collection_mode === 'manual';

    if (!bannerInfo.isActive) return null;

    return ( 
        <BannerTemplate type={bannerInfo.type} withIcon={false} additionalClass="rounded-t-xs rounded-b-none bg-icoRed-400">
            <div className="text-center text-white">
                <Trans
                    i18nKey={classNames({
                        'layout_platform:global_info_disclaimer.past_due_admin_auto': isAdmin && !isManualSubscription,
                        'layout_platform:global_info_disclaimer.past_due_team_member_auto': !isAdmin && !isManualSubscription,
                        'layout_platform:global_info_disclaimer.past_due_admin_manual': isAdmin && isManualSubscription,
                        'layout_platform:global_info_disclaimer.past_due_team_member_manual': !isAdmin && isManualSubscription
                    })}
                    components={{
                        linkSubscription: (
                            <Link
                                className="underline"
                                href={{
                                    pathname: SUBSCRIPTION_INVOICES,
                                    query: { step: CHANGE_PAYMENT_METHOD }
                                }}
                            />
                        )
                    }}
                />
            </div>
        </BannerTemplate>
    );
}
